export const apiBaseUrl = process.env.NODE_ENV === "production"
  ? "api.creator.thumpasaurus.com"
  : "bb.ngrok.io"

export const wsProtocol = process.env.NODE_ENV === "production"
  ? "wss"
  : "ws"